import * as React from 'react';
/**
 * Component intended for use as a child of the `<Experiment>` component to conditionally
 * render a variant of an experiment content based on experiment bucket.
 */
export var ExperimentVariant = function (props) {
  return React.createElement(React.Fragment, null, props.children || null);
};